"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var cropLabelStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

function _default(props) {
  var theme = props.theme;
  var error = props.error,
      disabled = props.disabled,
      readOnly = props.readOnly,
      cropLabel = props.cropLabel,
      hover = props.hover,
      active = props.active;
  theme = _objectSpread({}, theme, {
    labelColor: theme.idleLabelColor
  });

  if (hover) {
    theme = _objectSpread({}, theme, {
      labelColor: theme.hoverLabelColor
    });
  }

  if (active) {
    theme = _objectSpread({}, theme, {
      labelColor: error ? theme.errorLabelColor : theme.focusLabelColor
    });
  }

  if (disabled || readOnly) {
    theme = _objectSpread({}, theme, {
      labelColor: theme.disabledLabelColor
    });
  }

  return _objectSpread({
    fontSize: theme.labelFontSize,
    lineHeight: theme.labelLineHeight,
    color: theme.labelColor,
    textWrap: 'none',
    whiteSpace: 'nowrap',
    wordWrap: 'normal',
    width: '100%',
    display: 'block',
    textAlign: 'left'
  }, cropLabel ? cropLabelStyles : {});
}